import createTargetObjectCanvas from '@/components/ProductProfile/utils/drawSection/createTargetObjectCanvas'
import applyCanvasOverlayWithShader from '@/components/ProductProfile/utils/drawSection/applyShaderOnMaterial'
import mergeSections from '@/components/ProductProfile/utils/drawSection/mergeSections'

const cleanTargetObject = async (name: string, sections: any[] = []) => {
  console.log('----')
  if (sections.length === 0) {
    await createTargetObjectCanvas({
      name: name,
      items: [],
      size: { width: 1, height: 1 },
      singleSectionId: null,
    })
  } else {
    const data = mergeSections(name, sections)
    if (!data) return

    await createTargetObjectCanvas({ ...data, singleSectionId: null })
  }

  await applyCanvasOverlayWithShader(name)
}

export default cleanTargetObject
